export default __webpack_public_path__ + "static/media/factory__10.c2052713.jpg";